import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function Benefits() {
  const benefits = ['Cómo crear productos digitales rentables con IA (sin ser experto en tecnología)', 'El sistema exacto para vender en piloto automático', 'Cómo empezar desde cero, aunque no tengas experiencia', 'Las herramientas de IA que hacen todo el trabajo pesado por ti'];
  const notRequired = ['Experiencia previa', 'Conocimientos técnicos', 'Gran inversión inicial'];
  return <section data-id="element-63">
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-64">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-10 text-center leading-tight" data-id="element-65">
          En esta masterclass gratuita descubrirás:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 max-w-5xl mx-auto" data-id="element-66">
          <div data-id="element-67">
            <div className="flex items-center justify-center mb-6" data-id="element-68">
              <div className="bg-red-600 bg-opacity-20 rounded-full p-3" data-id="element-69">
                <XIcon className="h-8 w-8 text-red-500" data-id="element-70" />
              </div>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-red-400" data-id="element-71">
              No necesitas
            </h3>
            <ul className="space-y-4" data-id="element-72">
              {notRequired.map((item, index) => <li key={index} className="flex items-start" data-id="element-73">
                  <XIcon className="h-6 w-6 text-red-500 mr-3 flex-shrink-0 mt-1" data-id="element-74" />
                  <span className="text-base md:text-lg leading-relaxed" data-id="element-75">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-76">
            <div className="flex items-center justify-center mb-6" data-id="element-77">
              <div className="bg-green-600 bg-opacity-20 rounded-full p-3" data-id="element-78">
                <CheckIcon className="h-8 w-8 text-green-500" data-id="element-79" />
              </div>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-green-400" data-id="element-80">
              Lo que aprenderás
            </h3>
            <ul className="space-y-4" data-id="element-81">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-82">
                  <CheckIcon className="h-6 w-6 text-green-500 mr-3 flex-shrink-0 mt-1" data-id="element-83" />
                  <span className="text-base md:text-lg leading-relaxed" data-id="element-84">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700" data-id="element-85">
          <p className="text-xl md:text-2xl text-center font-medium leading-relaxed" data-id="element-86">
            Solo necesitas 90 minutos y ganas de aprender.
          </p>
        </div>
      </div>
    </section>;
}